import * as data from '../../app-version.json'

const version = data.version

export default version
